import * as webcc from "webcc";
import React from "react";
import { LeftTab } from "./components/LeftTab";
import { RightTab } from "./components/RightTab";
import { Sidebar } from "./components/Sidebar";
import { HeaderMenu } from "./components/HeaderMenu";
import { WebccContext } from "./contexts/WebccContext";
import { useContext, useEffect } from "react";
import { leftTabs, rightTabs } from "./data/data";
import { SidebarProvider } from "./contexts/sidebarContext";
import { webccTheme } from "./styles/theme";
import { EventData } from "./data/interfaces/eventData";
import { SelectionObserver } from "./components/rightTabComponents/SelectionObserver";
import { LoadingOverlay } from "./components/LoadingOverlay";
import { DesenhadorProps } from "./data/cemweb";

const eventTypes = webcc.EventType;

const eventsToSubscribe = [
  eventTypes.frame_settings,
  eventTypes.sash_group_settings,
  eventTypes.sash_settings,
  eventTypes.sash_bar_settings,
  eventTypes.glass_hole_settings,
  eventTypes.note_settings,
  eventTypes.filler_settings,
  eventTypes.bar_modifier,
];

export default function Home(props: DesenhadorProps) {
  const { cc, setWebcc, setEvent, isProcessing } = useContext(WebccContext);
  
  useEffect(() => {
    setWebcc();
  }, []);

  useEffect(() => {
    if(cc){
      cc.shapeManager.dimFontSize = webccTheme.dimFontSize;
      cc.shapeManager.barNormal = webccTheme.startProfileWebccColor;
      cc.shapeManager.fixedBeadShown = false;
      cc.shapeManager.sashBeadShown = false;
      cc.shapeManager.glassColor = webccTheme.startGlassWebccColor;
      cc.shapeManager.profileSize = { frameMullion: cc.shapeManager.profileSize.sashMullion };
      cc.langMode = "en-US";

      eventsToSubscribe.forEach((evt) => {
        cc.eventBus.select(evt).subscribe(
          (event: EventData) => {
            setEvent(event);
          }
        );
      });
    }
  }, [cc]);

  return (
    <>
      <HeaderMenu {...props}/>
      <SidebarProvider>
        <Sidebar position="left">
          <LeftTab tabs={leftTabs}/>
        </Sidebar>
        <Sidebar position="right">
          <RightTab tabs={rightTabs}/>
        </Sidebar>
        <SelectionObserver />
      </SidebarProvider>
      <div id="webcc" style={{ height: "100vh", width: "100vw" }} />
      { isProcessing && <LoadingOverlay/> }
    </>
  );
}